import React from "react";
import {
  Dialog,
  DialogActions,
  Divider,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";


const useStyles = makeStyles((theme) => ({
  categoryModal: {
    minWidth: 400,
    padding: theme.spacing(3),
  },
  modalTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
  },
  btn: {
    borderRadius: "10px",
    padding: theme.spacing(1, 4),
    color: "#FFFFFF",
  },
  titleHead: {
    fontWeight: "bold",
    fontSize: "1rem",
  },

  cancelBtn: {
    background: "linear-gradient(90.49deg, #373738 -0.38%, #565656 99.9%)",
    "&:hover": {
      background: "linear-gradient(90.49deg, #2c2c2d -0.38%, #484848 99.9%)",
    },
    border: "1px",
  },
  verifyBtn: {
    background: "linear-gradient(90deg, #A21717 0%, #A91067 100%)",
    color: "white",
    "&:hover": {
      background: "linear-gradient(90deg, #A21717 0%, #A91067 100%);",
    },
  },
  header: {
    padding: theme.spacing(1, 3),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "1.5rem",
    color: theme.palette.text.primary,
  },
  actionButtons: {
    padding: theme.spacing(2  , 3),
  },
  listItem: {
    fontSize: "1.5rem",
  },
}));

const ConfirmCloseModal = ({
  open,
  onClose,
  handleVerifyTicket,
  selectedRow,
}) => {
  const classes = useStyles();


  const handleCancel = () => {
    onClose();
  };
  const handleVerify = () => {
    handleVerifyTicket(selectedRow.ticketNumber, selectedRow.id);
    onClose();
  };

  return (
    <Dialog fullWidth open={open} onClose={() => onClose()}>
      <div className={classes.header}>
        <Grid
          container
          style={{ justifyContent: "space-between" }}
          alignItems="center"
          spacing={4}
        >
          <Grid item>
            <Typography
              className={classes.title}
              variant="h4"
              id="upload-document-modal"
            >
              Confirm Close
            </Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleCancel} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </div>
      <Divider />

      <DialogContent className={classes.categoryModal}>
        <Typography className={classes.titleHead} variant="h6">
          Do you want to Close ticket number : {selectedRow.ticketNumber}
        </Typography>
      </DialogContent>
      <DialogActions>
        <div className={classes.actionButtons}>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                onClick={handleCancel}
                color="default"
                className={[classes.btn, classes.cancelBtn]}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleVerify}
                variant="contained"
                className={[classes.btn, classes.verifyBtn]}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </div>
      </DialogActions>
    </Dialog>
  );
};

ConfirmCloseModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleVerifyTicket: PropTypes.func.isRequired,
  selectedRow: PropTypes.any,
};

export default ConfirmCloseModal;
